import React from "react";
import {
  Modal,
  ModalContent,
  ModalBody,
} from "@heroui/react";

export interface ModalProps {
  children: React.ReactNode;
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  onAction?: () => void;
  actionButtonText?: string;
  closeButtonText?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "full";
  scrollBehavior?: "inside" | "outside";
}

export function ReusableModal({
  children,
  isOpen,
  onClose,
  size = "md",
  scrollBehavior = "inside"
}: ModalProps) {



  return (
    <Modal
      isOpen={isOpen}
      scrollBehavior={scrollBehavior}
      onOpenChange={onClose}
      size={size}
    >
      <ModalContent>
        {() => (
          <>
            <ModalBody>
              {children}
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}

export default ReusableModal;

